import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAssetList,
  unloadAssetList
} from "../../redux/actions/asset.actions";
import AssetList from "../../components/AssetList";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

function Assets() {
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAssetList(1, "all"));
    return () => dispatch(unloadAssetList());
  }, []);

  if (!asset.assets) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"assets"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"assets"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <Link className="header-button" to="/assets/add">
                  {t("asset.create_button")}
                </Link>
                <Link className="header-button" to="/assets/import">
                  {t("asset.import_button")}
                </Link>
                <h2>{t("asset.list_title")}</h2>
              </div>
              <AssetList data={asset.assets} />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Assets;
